import { render, staticRenderFns } from "./WayGoodsDetail.vue?vue&type=template&id=e32baf40&scoped=true&"
import script from "./WayGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./WayGoodsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32baf40",
  null
  
)

export default component.exports